{
  "reference": "المرجع",
  "generic": {
    "title": "حدث خطأ غير متوقع",
    "detail": "حاول مرة أخرى. إذا تكرر الخطأ، تواصل مع الدعم واذكر رقم المرجع."
  },
  "status": {
    "400": {
      "title": "الطلب غير صحيح",
      "detail": "راجع البيانات وحاول مرة أخرى."
    },
    "401": {
      "title": "سجّل الدخول للمتابعة",
      "detail": "انتهت جلستك أو لم تسجّل الدخول."
    },
    "403": {
      "title": "ليس لديك صلاحية",
      "detail": "دورك في الفريق لا يسمح بهذا الإجراء. اطلبه من المالك أو المدير."
    },
    "404": {
      "title": "غير موجود",
      "detail": "لم نعثر على ما تبحث عنه. ربما حُذف أو نُقل."
    },
    "409": {
      "title": "تعارض في البيانات",
      "detail": "تغيّرت البيانات من مكان آخر. حدّث الصفحة وحاول مرة أخرى."
    },
    "422": {
      "title": "راجع الحقول",
      "detail": "بعض الحقول تحتاج إلى تصحيح."
    },
    "429": {
      "title": "عدد كبير من الطلبات",
      "detail": "انتظر قليلًا وحاول مرة أخرى."
    },
    "500": {
      "title": "حدث خطأ لدينا",
      "detail": "حاول مرة أخرى بعد قليل."
    }
  },
  "codes": {
    "network_error": {
      "title": "تعذّر الاتصال",
      "detail": "تأكد من اتصالك بالإنترنت وحاول مرة أخرى."
    },
    "invalid_credentials": {
      "title": "البريد أو كلمة المرور غير صحيحة",
      "detail": "تأكد منهما وحاول مرة أخرى، أو اطلب رابطًا لتعيين كلمة مرور جديدة."
    },
    "email_not_verified": {
      "title": "أكّد بريدك أولًا",
      "detail": "أرسلنا لك رابط التأكيد عند التسجيل. افتحه ثم سجّل الدخول."
    },
    "session_expired": {
      "title": "انتهت الجلسة",
      "detail": "سجّل الدخول مرة أخرى للمتابعة."
    },
    "unauthenticated": {
      "title": "سجّل الدخول للمتابعة",
      "detail": "هذه الصفحة متاحة بعد تسجيل الدخول فقط."
    },
    "forbidden": {
      "title": "ليس لديك صلاحية",
      "detail": "دورك في الفريق لا يسمح بهذا الإجراء. اطلبه من المالك أو المدير."
    },
    "not_found": {
      "title": "غير موجود",
      "detail": "لم نعثر على ما تبحث عنه. ربما حُذف أو نُقل."
    },
    "server_not_found": {
      "title": "لم نعثر على هذا السيرفر",
      "detail": "ربما حُذف أو يتبع شركة أخرى."
    },
    "invalid_token": {
      "title": "الرابط غير صالح",
      "detail": "تأكد من أنك فتحت الرابط كاملًا من آخر رسالة وصلتك."
    },
    "token_expired": {
      "title": "انتهت صلاحية الرابط",
      "detail": "رابط تأكيد البريد صالح 24 ساعة، ورابط إعادة تعيين كلمة المرور صالح ساعة واحدة. اطلب رابطًا جديدًا."
    },
    "token_used": {
      "title": "استُخدم هذا الرابط من قبل",
      "detail": "سجّل الدخول، أو اطلب رابطًا جديدًا."
    },
    "challenge_expired": {
      "title": "انتهت مهلة الرمز",
      "detail": "ارجع إلى صفحة تسجيل الدخول وابدأ من جديد."
    },
    "validation_failed": {
      "title": "راجع الحقول",
      "detail": "بعض الحقول تحتاج إلى تصحيح."
    },
    "no_organization": {
      "title": "لا توجد شركة مرتبطة بحسابك",
      "detail": "تواصل مع مالك الحساب ليرسل لك دعوة."
    },
    "internal_error": {
      "title": "حدث خطأ لدينا",
      "detail": "حاول مرة أخرى بعد قليل."
    },
    "not_implemented": {
      "title": "غير متاح بعد",
      "detail": "هذا الإجراء غير متاح في الإصدار الحالي."
    },
    "payment_method_required": {
      "title": "لا توجد طريقة دفع محفوظة",
      "detail": "تُحفظ طريقة الدفع مع أول دفعة. ادفع أولًا، ثم حاول مرة أخرى."
    },
    "trial_server_limit": {
      "title": "وصلت إلى حد سيرفرات التجربة",
      "detail": "التجربة المجانية تشمل حتى 3 سيرفرات. يمكنك إضافة المزيد بعد بدء اشتراكك المدفوع."
    },
    "downgrade_capacity_exceeded": {
      "title": "حسابات الاستضافة أكثر من سعة الباقة",
      "detail": "احذف بعض الحسابات أو انقلها من السيرفر أولًا، أو اختر باقة أكبر."
    },
    "plan_unchanged": {
      "title": "هذه باقتك الحالية",
      "detail": "اختر باقة أو دورة فوترة مختلفة."
    },
    "server_cancelling": {
      "title": "اشتراك هذا السيرفر ينتهي قريبًا",
      "detail": "تراجع عن الإلغاء أولًا، ثم غيّر الباقة."
    },
    "server_not_cancelling": {
      "title": "الاشتراك غير ملغى",
      "detail": "اشتراك هذا السيرفر يتجدد تلقائيًا."
    },
    "server_not_pending": {
      "title": "السيرفر مفعّل بالفعل",
      "detail": "هذا الإجراء للسيرفرات التي تنتظر التفعيل فقط."
    },
    "server_pending_use_remove": {
      "title": "السيرفر لم يتفعّل بعد",
      "detail": "لا يوجد اشتراك مدفوع لإلغائه. احذف السيرفر بدلًا من ذلك."
    },
    "transfer_in_progress": {
      "title": "يوجد نقل قيد التنفيذ",
      "detail": "انتظر حتى يتوقف التثبيت القديم، ثم حاول مرة أخرى."
    },
    "transfer_not_allowed": {
      "title": "النقل غير متاح الآن",
      "detail": "يمكنك نقل السيرفر عندما يكون اشتراكه فعّالًا أو في فترة التجربة. سدّد المبلغ المستحق أولًا."
    },
    "transfer_too_soon": {
      "title": "نقلت هذا السيرفر مؤخرًا",
      "detail": "يمكنك نقل السيرفر مرة كل 30 يومًا، والنقل التالي متاح في {{date}}. تواصل مع الدعم إذا احتجت إلى النقل الآن."
    },
    "device_code_not_found": {
      "title": "الرمز غير صحيح",
      "detail": "تأكد من أنك كتبت الرمز كما يظهر على السيرفر."
    },
    "device_code_expired": {
      "title": "انتهت صلاحية الرمز",
      "detail": "الرمز صالح لمدة 15 دقيقة. شغّل أمر التثبيت مرة أخرى لتحصل على رمز جديد."
    },
    "device_code_used": {
      "title": "استُخدم هذا الرمز من قبل",
      "detail": "كل رمز يُستخدم مرة واحدة. شغّل أمر التثبيت مرة أخرى لتحصل على رمز جديد."
    },
    "member_not_found": {
      "title": "لم نعثر على هذا العضو",
      "detail": "ربما حُذف من الفريق. حدّث الصفحة."
    },
    "owner_role_locked": {
      "title": "لا يمكن تغيير دور المالك",
      "detail": "لتغيير المالك، انقل الملكية من صفحة الفريق."
    },
    "cannot_change_own_role": {
      "title": "لا يمكنك تغيير دورك",
      "detail": "اطلب من المالك أو من مدير آخر أن يغيّره لك."
    },
    "owner_cannot_leave": {
      "title": "لا يمكن للمالك مغادرة الفريق",
      "detail": "انقل الملكية إلى عضو آخر أولًا، ثم غادر."
    },
    "owner_cannot_be_removed": {
      "title": "لا يمكن إزالة المالك",
      "detail": "يبقى المالك في الفريق حتى ينقل الملكية."
    },
    "already_owner": {
      "title": "أنت المالك",
      "detail": "اختر عضوًا آخر لنقل الملكية."
    },
    "transfer_requires_2fa": {
      "title": "على المالك الجديد تفعيل المصادقة الثنائية",
      "detail": "اطلب منه تفعيلها من الإعدادات، ثم حاول مرة أخرى."
    },
    "invitation_not_found": {
      "title": "لم نعثر على الدعوة",
      "detail": "ربما قُبلت أو أُلغيت. حدّث الصفحة."
    },
    "invite_recently_sent": {
      "title": "أرسلنا الدعوة قبل لحظات",
      "detail": "انتظر دقيقة قبل إعادة الإرسال."
    },
    "too_many_invitations": {
      "title": "لديك دعوات مفتوحة كثيرة",
      "detail": "ألغِ بعض الدعوات القديمة قبل إرسال دعوات جديدة."
    },
    "two_factor_required_to_enforce": {
      "title": "فعّل المصادقة الثنائية لحسابك أولًا",
      "detail": "لا يمكنك إلزام الفريق بها قبل أن تفعّلها لحسابك."
    },
    "invitation_used": {
      "title": "قُبلت هذه الدعوة من قبل",
      "detail": "سجّل الدخول للمتابعة."
    },
    "invitation_revoked": {
      "title": "أُلغيت الدعوة",
      "detail": "اطلب دعوة جديدة من مالك الحساب أو مديره."
    },
    "invitation_expired": {
      "title": "انتهت صلاحية الدعوة",
      "detail": "الدعوة صالحة لمدة 7 أيام. اطلب دعوة جديدة."
    },
    "invitation_email_mismatch": {
      "title": "الدعوة مرسلة إلى بريد آخر",
      "detail": "سجّل الخروج، ثم سجّل الدخول بالبريد الذي وصلته الدعوة."
    },
    "account_exists": {
      "title": "لديك حساب بهذا البريد",
      "detail": "سجّل الدخول لقبول الدعوة."
    },
    "ticket_not_found": {
      "title": "لم نعثر على التذكرة",
      "detail": "ربما الرابط قديم، أو التذكرة تخص شركة أخرى."
    },
    "ticket_reopen_window_passed": {
      "title": "مرّ أكثر من 14 يومًا على حل التذكرة",
      "detail": "افتح تذكرة جديدة واذكر رقم هذه التذكرة."
    },
    "ticket_not_resolved": {
      "title": "التذكرة ما زالت مفتوحة",
      "detail": "يمكنك تقييم الدعم بعد حل التذكرة."
    },
    "ticket_already_rated": {
      "title": "قيّمت هذه التذكرة من قبل",
      "detail": "شكرًا، وصلنا تقييمك."
    },
    "diagnostics_unavailable": {
      "title": "لا توجد بيانات تشخيص",
      "detail": "لم يتصل السيرفر بعد، لذلك لا توجد لدينا بيانات منه."
    },
    "release_not_found": {
      "title": "لم نعثر على هذا الإصدار",
      "detail": "ربما رقم الإصدار غير صحيح، أو لم يُنشر بعد."
    },
    "two_factor_already_on": {
      "title": "المصادقة الثنائية مفعّلة",
      "detail": "حسابك محمي بها، ولا تحتاج إلى إعدادها مرة أخرى."
    },
    "two_factor_setup_expired": {
      "title": "انتهت مهلة الإعداد",
      "detail": "ابدأ إعداد المصادقة الثنائية من جديد."
    },
    "two_factor_required_by_org": {
      "title": "شركتك تشترط المصادقة الثنائية",
      "detail": "لا يمكنك إيقافها لأن إحدى شركاتك تشترطها على كل الأعضاء."
    },
    "two_factor_off": {
      "title": "المصادقة الثنائية غير مفعّلة",
      "detail": "فعّلها أولًا للحصول على رموز الاسترداد."
    },
    "session_not_found": {
      "title": "لم نعثر على الجلسة",
      "detail": "ربما انتهت بالفعل. حدّث القائمة."
    },
    "cannot_revoke_current_session": {
      "title": "هذه جلستك الحالية",
      "detail": "لإنهائها، سجّل الخروج من قائمة الحساب."
    },
    "preference_locked": {
      "title": "هذا الإشعار مطلوب",
      "detail": "لا يمكنك إيقاف هذا البريد بحكم دورك في الفريق."
    },
    "org_has_active_servers": {
      "title": "لديك سيرفرات فعّالة",
      "detail": "ألغِ اشتراكات كل السيرفرات قبل حذف الشركة."
    },
    "org_has_balance": {
      "title": "عليك مبلغ مستحق",
      "detail": "سدّد المبلغ المستحق قبل حذف الشركة."
    },
    "email_taken": {
      "title": "هذا البريد مستخدم",
      "detail": "استخدم بريدًا آخر."
    },
    "invoice_not_found": {
      "title": "لم نعثر على الفاتورة",
      "detail": "ربما حُذفت، أو تخص شركة أخرى."
    },
    "invoice_not_payable": {
      "title": "لا يمكن دفع هذه الفاتورة",
      "detail": "الفاتورة مدفوعة أو ملغاة أو مستردة."
    },
    "payment_method_not_found": {
      "title": "لم نعثر على طريقة الدفع",
      "detail": "ربما حُذفت. حدّث الصفحة واختر طريقة أخرى."
    },
    "payment_method_required_for_subscriptions": {
      "title": "احتفظ بطريقة دفع واحدة على الأقل",
      "detail": "اشتراكاتك الفعّالة تتجدد بطريقة دفع محفوظة. أضف طريقة أخرى قبل حذف هذه الطريقة."
    },
    "payment_method_limit": {
      "title": "وصلت إلى الحد الأقصى",
      "detail": "يمكنك حفظ حتى 5 طرق دفع. احذف واحدة قبل إضافة أخرى."
    },
    "payment_method_duplicate": {
      "title": "طريقة الدفع هذه محفوظة بالفعل",
      "detail": "اخترها من طرق الدفع."
    },
    "payment_method_expired": {
      "title": "انتهت صلاحية البطاقة",
      "detail": "اختر طريقة دفع أخرى أو أضف بطاقة جديدة."
    },
    "payment_not_found": {
      "title": "لم نعثر على الدفعة",
      "detail": "حدّث الصفحة وراجع المدفوعات."
    },
    "subscription_not_found": {
      "title": "لم نعثر على الاشتراك",
      "detail": "ربما يخص سيرفرًا محذوفًا."
    },
    "subscription_past_due": {
      "title": "ادفع مبلغ التجديد أولًا",
      "detail": "لم تنجح دفعة التجديد. ادفعها، ثم غيّر الباقة."
    },
    "subscription_cancel_scheduled": {
      "title": "هذا الاشتراك سينتهي قريبًا",
      "detail": "تراجع عن الإلغاء أولًا، ثم غيّر الباقة."
    },
    "no_scheduled_change": {
      "title": "لا يوجد تغيير مجدول",
      "detail": "لا يوجد تغيير باقة ينتظر هذا الاشتراك."
    },
    "ai_unavailable": {
      "title": "الذكاء الاصطناعي غير متاح على هذا السيرفر",
      "detail": "السيرفر لم يُفعَّل بعد، أو لوحة التحكم مقفلة، أو السيرفر غير متصل منذ مدة. يمكنك شراء النقاط بعد حل ذلك."
    },
    "checkout_cancelled": {
      "title": "أُلغي الدفع",
      "detail": "أُلغيت جلسة الدفع هذه. ابدأ الدفع من جديد."
    },
    "checkout_completed": {
      "title": "تم الدفع بالفعل",
      "detail": "اكتملت جلسة الدفع هذه."
    },
    "checkout_expired": {
      "title": "انتهت مهلة جلسة الدفع",
      "detail": "لم يُخصم أي مبلغ. ابدأ الدفع من جديد."
    },
    "checkout_not_found": {
      "title": "لم نعثر على جلسة الدفع",
      "detail": "ابدأ الدفع من جديد."
    },
    "checkout_not_needed": {
      "title": "لا يوجد شيء تدفعه الآن",
      "detail": "حدّث الصفحة وراجع حالة الاشتراك."
    },
    "checkout_required": {
      "title": "هذا الإجراء يتطلب الدفع",
      "detail": "تابع إلى الدفع لإكمال التغيير."
    },
    "payment_already_set_up": {
      "title": "الدفع جاهز بالفعل",
      "detail": "طريقة الدفع محفوظة لهذا الاشتراك. يمكنك تغييرها من إدارة طرق الدفع."
    },
    "portal_session_expired": {
      "title": "انتهت مهلة جلسة البوابة",
      "detail": "ارجع إلى bPanel وافتح إدارة طرق الدفع مرة أخرى."
    },
    "portal_session_not_found": {
      "title": "لم نعثر على جلسة البوابة",
      "detail": "ارجع إلى bPanel وافتح إدارة طرق الدفع مرة أخرى."
    },
    "purchase_not_found": {
      "title": "لم نعثر على عملية الشراء",
      "detail": "حدّث الصفحة وراجع مشتريات النقاط."
    },
    "server_locked": {
      "title": "لوحة تحكم هذا السيرفر مقفلة",
      "detail": "انتهى الاشتراك. جدّده أولًا، ثم حاول مرة أخرى."
    },
    "server_paid_use_cancel": {
      "title": "اشتراك هذا السيرفر مدفوع",
      "detail": "لا يمكن حذف سيرفر له فترة مدفوعة. ألغِ الاشتراك بدلًا من ذلك."
    },
    "subscription_ended": {
      "title": "انتهى الاشتراك",
      "detail": "جدّد الاشتراك أولًا، ثم غيّر الباقة."
    },
    "subscription_incomplete": {
      "title": "السيرفر بانتظار أول دفعة",
      "detail": "ادفع الفترة الأولى، ثم ثبّت bPanel على السيرفر وفعّله."
    },
    "subscription_revoked": {
      "title": "ترخيص هذا السيرفر موقوف",
      "detail": "لا يمكن تجديده من صفحة الدفع. تواصل مع الدعم."
    },
    "key_unavailable": {
      "title": "لا يمكن عرض مفتاح التفعيل",
      "detail": "أصدر مفتاحًا جديدًا لهذا السيرفر واستخدمه في أمر التثبيت. يتوقف المفتاح القديم عن العمل."
    },
    "key_storage_unavailable": {
      "title": "مفاتيح التفعيل غير متاحة الآن",
      "detail": "لدينا مشكلة مؤقتة في حفظ المفاتيح. حاول بعد قليل، وإذا استمرت المشكلة تواصل مع الدعم."
    },
    "device_activation_disabled": {
      "title": "التفعيل بالرمز متوقف حاليًا",
      "detail": "ثبّت السيرفر بمفتاح التفعيل بدلًا من الرمز. تجده في صفحة السيرفر."
    },
    "license_service_unavailable": {
      "title": "خدمة التراخيص غير متاحة الآن",
      "detail": "تعذّر الوصول إلى خدمة التراخيص. حاول مرة أخرى بعد دقائق."
    },
    "license_already_active": {
      "title": "السيرفر مفعّل من قبل",
      "detail": "لهذا السيرفر ترخيص فعّال. حدّث الصفحة."
    },
    "license_not_found": {
      "title": "لم نعثر على الترخيص",
      "detail": "ربما حُذف السيرفر أو نُقل إلى حساب آخر. حدّث الصفحة."
    },
    "provider_unavailable": {
      "title": "بوابة الدفع غير متاحة الآن",
      "detail": "تعذّر الوصول إلى Dodo Payments، ولم نخصم أي مبلغ. حاول مرة أخرى بعد دقائق."
    },
    "provider_rejected": {
      "title": "رفضت بوابة الدفع الطلب",
      "detail": "حاول مرة أخرى، وإذا تكرر الرفض تواصل مع الدعم."
    },
    "document_not_available": {
      "title": "مستند الفاتورة غير جاهز",
      "detail": "تصدر Dodo Payments المستند بعد الدفع. إذا دفعت للتو، انتظر دقيقة وحاول مرة أخرى."
    },
    "payment_not_set_up": {
      "title": "لا توجد طريقة دفع محفوظة",
      "detail": "لا توجد طريقة دفع محفوظة بعد. تُحفظ مع أول دفعة."
    },
    "payment_in_progress": {
      "title": "توجد دفعة قيد المعالجة",
      "detail": "انتظر حتى تكتمل الدفعة الحالية، ثم حاول مرة أخرى."
    },
    "price_not_available": {
      "title": "السعر غير متاح الآن",
      "detail": "حدّث الصفحة وحاول مرة أخرى، وإذا استمرت المشكلة تواصل مع الدعم."
    },
    "price_not_synced": {
      "title": "السعر غير جاهز للدفع بعد",
      "detail": "نجهّز السعر لدى بوابة الدفع. حاول مرة أخرى بعد دقائق."
    },
    "subscription_cancelling": {
      "title": "الاشتراك ملغى وينتهي قريبًا",
      "detail": "تراجع عن الإلغاء أولًا، ثم غيّر الباقة."
    },
    "subscription_not_cancelling": {
      "title": "الاشتراك غير ملغى",
      "detail": "لا يوجد إلغاء مجدول للتراجع عنه. حدّث الصفحة."
    },
    "subscription_not_changeable": {
      "title": "لا يمكن تغيير هذا الاشتراك الآن",
      "detail": "حالته الحالية لا تسمح بالتغيير. حدّث الصفحة وراجعها."
    },
    "signup_disabled": {
      "title": "التسجيل متوقف مؤقتًا",
      "detail": "لا نستقبل حسابات جديدة الآن. حاول لاحقًا أو تواصل معنا."
    },
    "too_many_attempts": {
      "title": "محاولات كثيرة",
      "detail": "انتظر 15 دقيقة، ثم حاول مرة أخرى."
    },
    "rate_limited": {
      "title": "عدد كبير من الطلبات",
      "detail": "انتظر قليلًا ثم حاول مرة أخرى."
    },
    "ip_not_allowed": {
      "title": "الدخول من هذا العنوان غير مسموح",
      "detail": "حسابك يسمح بالدخول من عناوين IP محددة فقط. اطلب من مالك الحساب أو مديره إضافة عنوانك."
    },
    "invalid_json": {
      "title": "الطلب غير مكتمل",
      "detail": "حدّث الصفحة وحاول مرة أخرى."
    },
    "version_conflict": {
      "title": "تغيرت البيانات",
      "detail": "غيّرها شخص آخر قبل لحظات. حدّث الصفحة وحاول مرة أخرى."
    }
  },
  "fields": {
    "required": "هذا الحقل مطلوب",
    "too_long": "النص أطول من المسموح",
    "invalid_email": "اكتب بريدًا إلكترونيًا صحيحًا",
    "password_too_short": "استخدم 10 أحرف على الأقل",
    "passwords_mismatch": "كلمتا المرور غير متطابقتين",
    "email_taken": "هذا البريد مسجل لدينا. سجّل الدخول بدلًا من ذلك.",
    "terms_required": "وافق على الشروط للمتابعة",
    "country_not_supported": "اختر دولة من دول الخليج",
    "invalid_code": "الرمز غير صحيح. حاول مرة أخرى",
    "invalid": "القيمة غير صحيحة",
    "invalid_hostname": "اكتب اسم مضيف كامل، مثل server1.example.sa",
    "hostname_taken": "لديك سيرفر بنفس اسم المضيف",
    "already_member": "أحد العناوين لعضو موجود في الفريق",
    "already_invited": "أحد العناوين لديه دعوة سارية",
    "too_many_emails": "حتى 10 عناوين في كل مرة",
    "too_short": "النص أقصر من المطلوب",
    "required_for_urgent": "اختر السيرفر المتأثر للتذاكر العاجلة",
    "diagnostics_unavailable": "لا توجد بيانات تشخيص من هذا السيرفر",
    "too_many_files": "حتى 5 ملفات",
    "file_too_large": "الملف أكبر من المسموح",
    "file_type_not_allowed": "نوع الملف غير مدعوم",
    "wrong_password": "كلمة المرور غير صحيحة",
    "same_email": "هذا بريدك الحالي",
    "password_reused": "اختر كلمة مرور مختلفة عن الحالية",
    "confirm_mismatch": "النص غير مطابق",
    "preference_locked": "هذا الإشعار مطلوب لدورك",
    "vat_sa_format": "15 رقمًا، يبدأ بالرقم 3 وينتهي به",
    "vat_ae_format": "15 رقمًا، يبدأ بـ 100",
    "vat_15_digits": "اكتب 15 رقمًا",
    "vat_om_format": "OM ثم 10 أرقام",
    "vat_not_applicable": "لا توجد ضريبة قيمة مضافة في هذه الدولة حاليًا",
    "cr_sa_format": "10 أرقام",
    "postal_sa_format": "5 أرقام",
    "duplicate_email": "البريد موجود في القائمة",
    "billing_emails_limit": "حتى 5 عناوين",
    "out_of_range": "الرقم خارج الحد المسموح",
    "limit_below_pack": "يجب أن يغطي الحد شحنة واحدة على الأقل",
    "no_change": "هذه باقتك الحالية"
  },
  "notFound": {
    "title": "الصفحة غير موجودة",
    "body": "ربما الرابط قديم أو مكتوب بشكل غير صحيح.",
    "home": "العودة إلى النظرة العامة",
    "code": "404"
  },
  "crash": {
    "title": "حدث خطأ في هذه الصفحة",
    "body": "سجلنا الخطأ. أعد تحميل الصفحة، وإذا تكرر تواصل مع الدعم.",
    "reload": "إعادة تحميل الصفحة",
    "home": "العودة إلى النظرة العامة"
  }
}
